import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import entityActionFactory from './factories/entityActionFactory';
import detailActionFactory from './factories/detailActionFactory';
import changeActionFactory from './factories/changeActionFactory';

// define the basic actions, and include page and change actions.
const detailActions = detailActionFactory('reportFilter', 'reportFilters');
const entityActions = entityActionFactory('reportFilter', 'reportFilters');
const changeActions = changeActionFactory('reportFilter', 'reportFilters');
const create = (reportFilterID, userID, reportFilters) => {
  const defaultData = _objectSpread(_objectSpread({}, reportFilters), {}, {
    id: reportFilterID,
    name: '',
    userID,
    sortOrder: 0
  });

  // note this is calling the original changeActions.create
  return changeActions.create(reportFilterID, defaultData);
};
const reportFilterActions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, entityActions), detailActions), changeActions), {}, {
  create
});
export default reportFilterActions;